<div [class.mobile-device]="isTouchEnabled()" [ngClass]="browser" class="h-100" appContextMenuClose>
	<router-outlet></router-outlet>
</div>
<div class="w-100 d-flex justify-content-center">
	<div class="orca-alert-global position-fixed">
		<app-alert [positionType]="alertPositionType.Global"></app-alert>
	</div>
</div>
